import { render, staticRenderFns } from "./SendEmailButton.vue?vue&type=template&id=04b58af0"
import script from "./SendEmailButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SendEmailButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports